export default __webpack_public_path__ + "static/media/invite.53c33b90.svg";